import { Button, Fab, useMediaQuery, FabProps, ButtonProps as MuiButtonProps } from '@mui/material'
import React from 'react'

export interface CustomButtonProps {
    buttonTitle?: string;
    buttonIcon?: React.ReactElement;
    buttonProps?: MuiButtonProps;
    fabProps?: FabProps;
    onbuttonClick?: any
}

const CustomButton = (props: CustomButtonProps) => {
    const { buttonProps, buttonTitle, buttonIcon, fabProps, onbuttonClick } = props;
    const isTab = useMediaQuery('(min-width:600px)');

    if (isTab)
        return <Button startIcon={buttonIcon} sx={{ mt: 0.5 }}
            variant='contained' onClick={onbuttonClick} {...buttonProps}>{buttonTitle}</Button>;
    
    return <Fab size='small' color='primary' onClick={onbuttonClick} {...fabProps}>
        {buttonIcon}
    </Fab>;
}

export default CustomButton